import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { API_URL } from '../utils/config';
import './Header.css';

const Header = () => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const { getCartItemsCount } = useCart();
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${searchQuery}`);
    }
  };

  const handleLogout = () => {
    logout();
    setShowProfileMenu(false);
    setMobileMenuActive(false);
    alert('Logged out successfully!');
    navigate('/');
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return '/img/default-avatar.png';
    if (imagePath.startsWith('/uploads/')) {
      return `${API_URL}${imagePath}`;
    }
    return imagePath;
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMobileMenu = () => {
    setMobileMenuActive(!mobileMenuActive);
  };

  return (
    <section id="header">
      {/* Logo */}
      <Link to="/" id="logo-link">
        <img id="logo" src="/img/logo.png" className="logo" alt="Gold Vines Logo" />
      </Link>

      {/* Brand Name */}
      <div id="shopname">
        <h3 className="brand-wordmark">
          <span className="brand-gold">Gold</span>
          <span className="brand-separator"> </span>
          <span className="brand-vines">Vines</span>
        </h3>
        <div className="brand-tagline">LUXURY COLLECTION</div>
      </div>

      {/* Search Bar */}
      <div className="Searchbox_Scalitan">
        <div className="searchbox">
          <form onSubmit={handleSearch}>
            <input
              type="text"
              placeholder="Search products"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
              <i className="fas fa-search"></i>
            </button>
          </form>
        </div>
      </div>

      {/* Navigation */}
      <div>
        <ul id="navbar" className={mobileMenuActive ? 'active' : ''}>
          <li>
            <Link to="/" className={isActive('/')} onClick={() => setMobileMenuActive(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/shop" className={isActive('/shop')} onClick={() => setMobileMenuActive(false)}>
              Shop
            </Link>
          </li>
          <li>
            <Link to="/design" className={isActive('/design')} onClick={() => setMobileMenuActive(false)}>
              Design
            </Link>
          </li>

          {isAuthenticated ? (
            <li className="user-menu">
              <div
                className="user-profile-header"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                <img
                  src={getImageUrl(user?.profileImage)}
                  alt={user?.fullName}
                  className="profile-avatar"
                  onError={(e) => { e.target.src = '/img/default-avatar.png'; }}
                />
                <span>{user?.fullName?.split(' ')[0]}</span>
                <i className="fas fa-chevron-down"></i>
              </div>

              {showProfileMenu && (
                <div className="profile-dropdown">
                  <Link to="/profile" onClick={() => { setShowProfileMenu(false); setMobileMenuActive(false); }}>
                    <i className="fas fa-user"></i> My Profile
                  </Link>
                  <Link to="/orders" onClick={() => { setShowProfileMenu(false); setMobileMenuActive(false); }}>
                    <i className="fas fa-shopping-bag"></i> My Orders
                  </Link>
                  <Link to="/address-book" onClick={() => { setShowProfileMenu(false); setMobileMenuActive(false); }}>
                    <i className="fas fa-map-marker-alt"></i> Address Book
                  </Link>
                  <button onClick={handleLogout}>
                    <i className="fas fa-sign-out-alt"></i> Logout
                  </button>
                </div>
              )}
            </li>
          ) : (
            <li><Link to="/login" onClick={() => setMobileMenuActive(false)}>Log in</Link></li>
          )}

          <li id="ig_bag">
            <Link to="/cart" onClick={() => setMobileMenuActive(false)}>
              <i className="far fa-shopping-bag"></i>
              {getCartItemsCount() > 0 && (
                <span className="cart-count">{getCartItemsCount()}</span>
              )}
            </Link>
          </li>
        </ul>
      </div>

      {/* Mobile Controls */}
      <div id="mobile">
        <Link to="/cart">
          <i className="far fa-shopping-bag" id="cart1"></i>
          {getCartItemsCount() > 0 && (
            <span className="cart-count">{getCartItemsCount()}</span>
          )}
        </Link>
        <i
          id="bar"
          className={mobileMenuActive ? "fas fa-times" : "fas fa-outdent"}
          onClick={toggleMobileMenu}
        ></i>
      </div>
    </section>
  );
};

export default Header;